import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetTramiteActividades, IGetUltimaActividadSeguimiento } from '../shared/interfaces/tramite';
import { API_URL } from 'lib-base';


@Injectable({
  providedIn: 'root'
})
export class TramActividadService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tram-actividad`;
  }


  getTramiteActividades(tramRegistroId: number): Observable<IGetTramiteActividades[]> {
    return this.http.get<IGetTramiteActividades[]>(`${this.baseUrl}/tramite/${tramRegistroId}`);
  }

  getTramiteActividadesByRadicado(radicado: string): Observable<IGetTramiteActividades[]> {
    return this.http.get<IGetTramiteActividades[]>(`${this.baseUrl}/public/tramite/${radicado}`);
  }

  getUltimaActividadSeguimiento(tramRegistroId: number): Observable<IGetUltimaActividadSeguimiento[]> {
    return this.http.get<IGetUltimaActividadSeguimiento[]>(`${this.baseUrl}/actividad-ultimo-seguimiento/${tramRegistroId}`);
  }
}
